import { render, staticRenderFns } from "./ProductForm.vue?vue&type=template&id=6d3a6510&"
import script from "./ProductForm.vue?vue&type=script&lang=js&"
export * from "./ProductForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d3a6510')) {
      api.createRecord('6d3a6510', component.options)
    } else {
      api.reload('6d3a6510', component.options)
    }
    module.hot.accept("./ProductForm.vue?vue&type=template&id=6d3a6510&", function () {
      api.rerender('6d3a6510', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/battery-store/products/ProductForm.vue"
export default component.exports